import CallLogWithDurationResourcePagingResultModel from '../../generated/types/model/resource/CallLogWithDurationResourcePagingResultModel';

export default class CallLogWithDurationResourcePagingResultViewModel extends CallLogWithDurationResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
